import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule, routingComponents} from './app-routing.module';
import {AppComponent} from './app.component';

// forms
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {environment} from '../environments/environment';

// Angular Material
import {MaterialModule} from './material/material.module';
import {LayoutModule} from '@angular/cdk/layout';

import {FlexLayoutModule} from '@angular/flex-layout';

// CKEditor
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {MainNavComponent} from './main-nav/main-nav.component';

import {SnackBarIconComponent} from './shared/snack-bar-icon/snack-bar-icon.component';
import {ConfirmComponent} from './shared/dialogs/confirm/confirm.component';
import {TextNamePipe} from './shared/pipes/text-name.pipe';
import {AlertComponent} from './shared/dialogs/alert/alert.component';
import {SituationIdToTextPipe} from './shared/pipes/situation-id-to-text.pipe';

import {AccountDialogComponent} from './account/dialogs/account-dialog/account-dialog.component';

import {AccountPasswordComponent} from './auth/account-password/account-password.component';
import {AccountProfileComponent} from './auth/account-profile/account-profile.component'
import {RegionalDialogComponent} from './regional/dialogs/regional-dialog/regional-dialog.component';

import {MemberFileDialogComponent} from './member/dialogs/member-file-dialog/member-file-dialog.component';

import {ProductDialogComponent} from './product/dialogs/product-dialog/product-dialog.component';
import {EventDialogComponent} from './event/dialogs/event-dialog/event-dialog.component';
import {RoomDialogComponent} from './room/dialogs/room-dialog/room-dialog.component';
import {EventDayDialogComponent} from './event/dialogs/event-day-dialog/event-day-dialog.component';
import {TeamRoleDialogComponent} from './team-role/dialogs/team-role-dialog/team-role-dialog.component';
import {EventActivityDialogComponent} from './event/dialogs/event-activity-dialog/event-activity-dialog.component';
import {EventTopicDialogComponent} from './event/dialogs/event-topic-dialog/event-topic-dialog.component';

import {EventPreviewDialogComponent} from './event/dialogs/event-preview-dialog/event-preview-dialog.component';
import {ProductLotDialogComponent} from './product/dialogs/product-lot-dialog/product-lot-dialog.component';
import {ProductPriceDialogComponent} from './product/dialogs/product-price-dialog/product-price-dialog.component';
import {OrderedComponent} from './ordered/ordered.component';
import {OrderedDialogComponent} from './ordered/dialogs/ordered-dialog/ordered-dialog.component';

import {StaffDialogComponent} from './staff/dialogs/staff-dialog/staff-dialog.component';
import {OrderedFileDialogComponent} from './ordered/dialogs/ordered-file-dialog/ordered-file-dialog.component';

import {TaxDialogComponent} from './tax/dialogs/tax-dialog/tax-dialog.component';
import {ProductCatPriceDialogComponent} from './product/dialogs/product-cat-price-dialog/product-cat-price-dialog.component';
import {PushDialogComponent} from './push/dialogs/push-dialog/push-dialog.component';

import {OrderedFailDialogComponent} from './ordered/dialogs/ordered-fail-dialog/ordered-fail-dialog.component';
import {OrderedViewerDialogComponent} from './ordered/dialogs/ordered-viewer-dialog/ordered-viewer-dialog.component';
import {SubcategoryDialogComponent} from './subcategory/dialogs/subcategory-dialog/subcategory-dialog.component';
import {NewsDialogComponent} from './news/dialogs/news-dialog/news-dialog.component';
import {SponsorDialogComponent} from './sponsor/dialogs/sponsor-dialog/sponsor-dialog.component';
import {SponsorCongressDialogComponent} from './sponsor-congress/dialogs/sponsor-congress-dialog/sponsor-congress-dialog.component';
import {PushSponsorDialogComponent} from './push-sponsor/dialogs/push-sponsor-dialog/push-sponsor-dialog.component';
import {WebnarViewDialogComponent} from './webnar/dialogs/webnar-view-dialog/webnar-view-dialog.component';
import {WebnarDialogComponent} from './webnar/dialogs/webnar-dialog/webnar-dialog.component';

import {ProductRefundDialogComponent} from './product/dialogs/product-refund-dialog/product-refund-dialog.component';
import {RefundDialogComponent} from './refund/dialogs/refund-dialog/refund-dialog.component';
import {EventSlotDialogComponent} from './event/dialogs/event-slot-dialog/event-slot-dialog.component';
import {TopicSlotDialogComponent} from './event/dialogs/topic-slot-dialog/topic-slot-dialog.component';
import {MemberDocumentDialogComponent} from './member/dialogs/member-document-dialog/member-document-dialog.component';
import {DocumentDialogComponent} from './document/dialogs/document-dialog/document-dialog.component';
import {VoucherDialogComponent} from './voucher/dialogs/voucher-dialog/voucher-dialog.component';
import {WaitingListDialogComponent} from './waiting-list/dialogs/waiting-list-dialog/waiting-list-dialog.component';
import {KnowledgeDialogComponent} from './knowledge/dialogs/knowledge-dialog/knowledge-dialog.component';

import {CompanionDialogComponent} from './companion/dialogs/companion-dialog/companion-dialog.component';
import {ConfigDialogComponent} from './config/dialogs/config-dialog/config-dialog.component';
import {TransferDialogComponent} from './transfer/dialogs/transfer-dialog/transfer-dialog.component';
import {EventTopicAgendaDialogComponent} from './event/dialogs/event-topic-agenda-dialog/event-topic-agenda-dialog.component';

import {HttpClientModule} from '@angular/common/http';

import {EventStaffDialogComponent} from './event/dialogs/event-staff-dialog/event-staff-dialog.component';
import {SubscriptionDialogComponent} from './subscriptions/dialogs/subscription-dialog/subscription-dialog.component';
import {BannerDialogComponent} from './event/dialogs/banner-dialog/banner-dialog.component';
import {ReportDialogComponent} from './reports/dialogs/report-dialog/report-dialog.component';
import {CriteriaDialogComponent} from './reports/dialogs/criteria-dialog/criteria-dialog.component';
import {UploadDocumentDialogComponent} from './document/dialogs/upload-document-dialog/upload-document-dialog.component';

import {MAT_DATE_LOCALE} from '@angular/material/core';

import {ReportSubscriptionDialogComponent} from './reports-subscriptions/dialogs/report-subscription-dialog/report-subscription-dialog.component';
import {CryptoService} from './services/crypto.service';
import {MemberChangedDialogComponent} from './dashboard/dialogs/member-changed-dialog/member-changed-dialog.component';

import {ReportSubscriptionStaffDialogComponent} from './reports-subscriptions/dialogs/report-subscription-staff-dialog/report-subscription-staff-dialog.component';
import {SpinnerComponent} from './shared/waiting/spinner.component';
import {MemberDataDialogComponent} from './event/dialogs/member-data-dialog/member-data-dialog.component';

import {AnnuityDialogComponent} from './annuity/dialogs/annuity-dialog/annuity-dialog.component';
import {AnnuityCatPriceDialogComponent} from './annuity/dialogs/annuity-cat-price-dialog/annuity-cat-price-dialog.component';
import {AnnuityLotDialogComponent} from './annuity/dialogs/annuity-lot-dialog/annuity-lot-dialog.component';
import {AnnuityPriceDialogComponent} from './annuity/dialogs/annuity-price-dialog/annuity-price-dialog.component';

import {AnnuityViewerDialogComponent} from './annuity/dialogs/annuity-viewer-dialog/annuity-viewer-dialog.component';
import {AnnuityPayDialogComponent} from './annuity/dialogs/annuity-pay-dialog/annuity-pay-dialog.component';
import {Gn1DialogComponent} from './gn1/dialogs/gn1-dialog/gn1-dialog.component';
import {MemberAnnotationDialogComponent} from './member/dialogs/member-annotation-dialog/member-annotation-dialog.component';
import {MemberLinksDialogComponent} from './member/dialogs/member-links-dialog/member-links-dialog.component';
import {MemberSubcategoryDialogComponent} from './member/dialogs/member-subcategory-dialog/member-subcategory-dialog.component';
import {MemberViewerDialogComponent} from './member/dialogs/member-viewer-dialog/member-viewer-dialog.component';
import {DocumentFolderDialogComponent} from './document/dialogs/document-folder-dialog/document-folder-dialog.component';
import {DocumentApproveDialogComponent} from './document/dialogs/document-approve-dialog/document-approve-dialog.component';
import {DocumentMoveDialogComponent} from './document/dialogs/document-move-dialog/document-move-dialog.component';
import {MemberPaymentDialogComponent} from './member/dialogs/member-payment-dialog/member-payment-dialog.component';
import {DepartmentDialogComponent} from './department/dialogs/department-dialog/department-dialog.component';
import {ConventionCenterDialogComponent} from './convention-center/dialogs/convention-center-dialog/convention-center-dialog.component';
import {ConventionRoomDialogComponent} from './convention-center/dialogs/convention-room-dialog/convention-room-dialog.component';
import {MemberCollectDialogComponent} from './member/dialogs/member-collect-dialog/member-collect-dialog.component';
import {PushMembersDialogComponent} from './push/dialogs/push-members-dialog/push-members-dialog.component';
import {MemberGN1DialogComponent} from './member-gn1/dialogs/member-gn1-dialog/member-gn1-dialog.component';
import {MemberGN1WorkDialogComponent} from './member-gn1-work/dialogs/member-gn1-work-dialog/member-gn1-work-dialog.component';
import {CarrousselComponent} from './shared/carroussel/carroussel.component';
import {FrontDeskRegisterConfirmComponent} from './balcony/pages/front-desk-register-confirm/front-desk-register-confirm.component';
import {MemberGn1ExcludedDialogComponent} from './member-gn1-work/dialogs/member-gn1-excluded-dialog/member-gn1-excluded-dialog.component';
import {MemberResidentDialogComponent} from './member/dialogs/member-resident-dialog/member-resident-dialog.component';
import {MemberTpiccvDialogComponent} from './member/dialogs/member-tpiccv-dialog/member-tpiccv-dialog.component';
import {MemberEducationDialogComponent} from './member/dialogs/member-reducation-dialog/member-education-dialog.component';
import {MemberBackgroundDialogComponent} from './member/dialogs/member-background-dialog/member-background-dialog.component';
import {SubcategoryDocDialogComponent} from './subcategory/dialogs/subcategory-doc-dialog/subcategory-doc-dialog.component';
import {ProductDocPriceDialogComponent} from './product/dialogs/product-doc-price-dialog/product-doc-price-dialog.component';
import {LetterSubscriptionDialogComponent} from './letters-subscriptions/dialogs/letter-subscription-dialog/letter-subscription-dialog.component';
import {LettersSpeakersDialogComponent} from './letters-speakers/dialogs/letters-speakers-dialog/letters-speakers-dialog.component';
import {LettersSpeakersPreviewDialogComponent} from './letters-speakers/dialogs/letters-speakers-preview-dialog/letters-speakers-preview-dialog.component';
import {InviteSpeakersDialogComponent} from './letters-speakers/dialogs/invite-speakers-dialog/invite-speakers-dialog.component';
import {SpeakerMemberDataDialogComponent} from './letters-speakers/dialogs/speaker-member-data-dialog/speaker-member-data-dialog.component';
import {CertificatesSubscriptionsDialogComponent} from './certificates-subscriptions/dialogs/certificates-subscriptions-dialog/certificates-subscriptions-dialog.component';
import {CertificatesSpeakersDialogComponent} from './certificates-speakers/dialogs/certificates-speakers-dialog/certificates-speakers-dialog.component';
import {CertificatesSpeakers_v2DialogComponent} from './certificates-speakers_v2/dialogs/certificates-speakers_v2-dialog/certificates-speakers_v2-dialog.component';

import {AnnuityLetterDialogComponent} from './annuity-letter/dialogs/annuity-letter-dialog/annuity-letter-dialog.component';
import {AnnuityValuesDialogComponent} from './annuity-letter/dialogs/annuity-values-dialog/annuity-values-dialog.component';
import {AnnuityConfirmationDialogComponent} from './annuity-letter/dialogs/annuity-confirmation-dialog/annuity-confirmation-dialog.component';
import {MemberEditPaymentDialogComponent} from './member/dialogs/member-edit-payment-dialog/member-edit-payment-dialog.component';

import {AngularFireModule} from '@angular/fire/compat';
import {AngularFirestoreModule} from '@angular/fire/compat/firestore';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFireStorageModule} from '@angular/fire/compat/storage';
import {AngularFireFunctionsModule} from '@angular/fire/compat/functions';

import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';

import {MatOptionModule} from '@angular/material/core';
import {DirectorsDialogComponent} from './site-pub/dialogs/directors-dialog/directors-dialog.component';
import {DirectorsPeriodDialogComponent} from './site-pub/dialogs/directors-period-dialog/directors-period-dialog.component';

import {StatuteDialogComponent} from './site-pub/dialogs/statute-dialog/statute-dialog.component';
import {HeaderDialogComponent} from './shared/headers/header-dialog.component';

import {ClipboardModule} from '@angular/cdk/clipboard';

import {DeptoDialogComponent} from './site-pub/dialogs/depto-dialog/depto-dialog.component';

import {ExamsDialogComponent} from './site-pub/dialogs/exams-dialog/exams-dialog.component';
import {RegionalsDialogComponent} from './site-pub/dialogs/regionals-dialog/regionals-dialog.component';

import {FileManagerComponent} from './shared/file-manager/file-manager.component';
import {CarouselDialogComponent} from './site-pub/dialogs/carousel-dialog/carousel-dialog.component';
import {SiteNewsDialogComponent} from './site-pub/dialogs/site-news-dialog/site-news-dialog.component';

import {LinkDialogComponent} from './site-pub/dialogs/link-dialog/link-dialog.component';
import {YoutubeDialogComponent} from './site-pub/dialogs/youtube-dialog/youtube-dialog.component';
import {GalleryDialogComponent} from './site-pub/dialogs/gallery-dialog/gallery-dialog.component';
import {GalleryListDialogComponent} from './site-pub/dialogs/gallery-list-dialog/gallery-list-dialog.component';
import {GalleryPhotoDialogComponent} from './site-pub/dialogs/gallery-photo-dialog/gallery-photo-dialog.component';
import {SiteEventDialogComponent} from './site-pub/dialogs/site-event-dialog/site-event-dialog.component';
import {BulletinDialogComponent} from './site-pub/dialogs/bulletin-dialog/bulletin-dialog.component';
import {BulletinPdfDialogComponent} from './site-pub/dialogs/bulletin-pdf-dialog/bulletin-pdf-dialog.component';
import {BulletinListDialogComponent} from './site-pub/dialogs/bulletin-list-dialog/bulletin-list-dialog.component';
import {MagazineDialogComponent} from './site-pub/dialogs/magazine-dialog/magazine-dialog.component';
import {TaviDocDialogComponent} from './site-pub/dialogs/tavi-doc-dialog/tavi-doc-dialog.component';
import {TaviProfsDialogComponent} from './site-pub/dialogs/tavi-profs-dialog/tavi-profs-dialog.component';
import {TaviCenterDialogComponent} from './site-pub/dialogs/tavi-center-dialog/tavi-center-dialog.component';
import {ResidentDialogComponent} from './site-pub/dialogs/resident-dialog/resident-dialog.component';
import {RegulationDialogComponent} from './site-pub/dialogs/regulation-dialog/regulation-dialog.component';
import {GuidelineDialogComponent} from './site-pub/dialogs/guideline-dialog/guideline-dialog.component';
import {CongressBeforeDialogComponent} from './site-pub/dialogs/congress-before-dialog/congress-before-dialog.component';
import {CongressBeforePdfDialogComponent} from './site-pub/dialogs/congress-before-pdf-dialog/congress-before-pdf-dialog.component';
import {MemberDialogComponent} from './member/dialogs/member-dialog/member-dialog.component';
import {SiteEventFormDialogComponent} from './site-pub/dialogs/site-event-form-dialog/site-event-form-dialog.component';
import {BecomeMemberDialogComponent} from './site-pub/dialogs/become-member-dialog/become-membe-dialog.component';
import {MemberOrderDateDialogComponent} from './member/dialogs/member-order-date-dialog/member-order-date-dialog.component';
import {CongressCurrentDialogComponent} from './site-pub/dialogs/congress-current-dialog/congress-current-dialog.component';
import {VimeoDialogComponent} from './site-pub/dialogs/vimeo-dialog/vimeo-dialog.component';
import {ArtigoCientificoDialogComponent} from './site-pub/dialogs/artigo-cientifico-dialog/artigo-cientifico-dialog.component';
import {PDFsDialogComponent} from './site-pub/dialogs/pdfs-dialog/pdfs-dialog.component';
import {MemberSiteChangedDialogComponent} from './dashboard/dialogs/member-site-changed-dialog/member-site-changed-dialog.component';
import { SiteLogsComponent } from './site-logs/site-logs.component';
import {ExhibitorPDFDialogComponent} from './site-pub/dialogs/exhibitor-pdf-dialog/exhibitor-pdf-dialog.component';
import {ExhibitorDialogComponent} from './site-pub/dialogs/exhibitor-dialog/exhibitor-dialog.component';
import {CountriesDialogComponent} from './countries/dialogs/countries-dialog/countries-dialog.component';
import { EventGuestDialogComponent } from './event-publish/dialogs/event-guest-dialog/event-guest-dialog.component';


@NgModule({
  declarations: [

    SpinnerComponent,

    AppComponent,
    routingComponents,
    MainNavComponent,
    SnackBarIconComponent,
    AccountDialogComponent,
    ConfirmComponent,
    TextNamePipe,
    MemberDialogComponent,
    AccountPasswordComponent,
    AccountProfileComponent,
    RegionalDialogComponent,
    MemberFileDialogComponent,
    ProductDialogComponent,
    RoomDialogComponent,
    TeamRoleDialogComponent,
    EventDialogComponent,
    EventDayDialogComponent,
    EventActivityDialogComponent,
    EventTopicDialogComponent,
    EventPreviewDialogComponent,
    ProductLotDialogComponent,
    ProductPriceDialogComponent,
    OrderedComponent,
    OrderedDialogComponent,
    TextNamePipe,
    AlertComponent,
    StaffDialogComponent,
    SituationIdToTextPipe,
    OrderedFileDialogComponent,
    TaxDialogComponent,
    ProductCatPriceDialogComponent,
    PushDialogComponent,
    OrderedFailDialogComponent,
    OrderedViewerDialogComponent,
    SubcategoryDialogComponent,
    NewsDialogComponent,
    SponsorDialogComponent,
    SponsorCongressDialogComponent,
    PushSponsorDialogComponent,
    WebnarViewDialogComponent,
    WebnarDialogComponent,
    ProductRefundDialogComponent,
    RefundDialogComponent,
    EventSlotDialogComponent,
    TopicSlotDialogComponent,
    MemberDocumentDialogComponent,
    DocumentDialogComponent,
    VoucherDialogComponent,
    WaitingListDialogComponent,
    KnowledgeDialogComponent,
    CompanionDialogComponent,
    ConfigDialogComponent,
    TransferDialogComponent,
    EventTopicAgendaDialogComponent,
    EventStaffDialogComponent,
    SubscriptionDialogComponent,
    BannerDialogComponent,
    ReportDialogComponent,
    CriteriaDialogComponent,
    UploadDocumentDialogComponent,
    ReportSubscriptionDialogComponent,
    MemberChangedDialogComponent,
    ReportSubscriptionStaffDialogComponent,
    MemberDataDialogComponent,
    AnnuityDialogComponent,
    AnnuityCatPriceDialogComponent,
    AnnuityLotDialogComponent,
    AnnuityPriceDialogComponent,
    AnnuityPayDialogComponent,
    AnnuityViewerDialogComponent,
    Gn1DialogComponent,
    MemberAnnotationDialogComponent,
    MemberLinksDialogComponent,
    MemberSubcategoryDialogComponent,
    MemberViewerDialogComponent,
    DocumentFolderDialogComponent,
    DocumentApproveDialogComponent,
    DocumentMoveDialogComponent,
    MemberPaymentDialogComponent,
    DepartmentDialogComponent,
    ConventionCenterDialogComponent,
    ConventionRoomDialogComponent,
    MemberCollectDialogComponent,
    PushMembersDialogComponent,
    MemberGN1DialogComponent,
    MemberGN1WorkDialogComponent,
    CarrousselComponent,
    FrontDeskRegisterConfirmComponent,
    MemberGn1ExcludedDialogComponent,
    MemberResidentDialogComponent,
    MemberTpiccvDialogComponent,
    MemberEducationDialogComponent,
    MemberBackgroundDialogComponent,
    SubcategoryDocDialogComponent,
    ProductDocPriceDialogComponent,
    LetterSubscriptionDialogComponent,
    LettersSpeakersDialogComponent,
    LettersSpeakersPreviewDialogComponent,
    InviteSpeakersDialogComponent,
    SpeakerMemberDataDialogComponent,
    CertificatesSubscriptionsDialogComponent,
    CertificatesSpeakersDialogComponent,
    CertificatesSpeakers_v2DialogComponent,
    AnnuityLetterDialogComponent,
    AnnuityValuesDialogComponent,
    AnnuityConfirmationDialogComponent,
    MemberEditPaymentDialogComponent,
    DirectorsDialogComponent,
    DirectorsDialogComponent, DirectorsPeriodDialogComponent,
    DirectorsPeriodDialogComponent,
    StatuteDialogComponent,
    StatuteDialogComponent,
    LinkDialogComponent,
    HeaderDialogComponent,
    DeptoDialogComponent,
    ExamsDialogComponent,

    RegionalsDialogComponent,

    FileManagerComponent,
    CarouselDialogComponent,
    SiteNewsDialogComponent,
    YoutubeDialogComponent,
    GalleryDialogComponent,
    GalleryListDialogComponent,
    GalleryPhotoDialogComponent,
    SiteEventDialogComponent,
    BulletinDialogComponent,
    BulletinListDialogComponent,
    BulletinPdfDialogComponent,
    MagazineDialogComponent,
    TaviDocDialogComponent,
    TaviProfsDialogComponent,
    TaviCenterDialogComponent,
    ResidentDialogComponent,
    RegulationDialogComponent,
    GuidelineDialogComponent,
    CongressBeforeDialogComponent,
    CongressBeforePdfDialogComponent,
    SiteEventFormDialogComponent,
    BecomeMemberDialogComponent,
    MemberOrderDateDialogComponent,
    CongressCurrentDialogComponent,
    VimeoDialogComponent,
    ArtigoCientificoDialogComponent,
    PDFsDialogComponent,
    MemberSiteChangedDialogComponent,
    SiteLogsComponent,
    ExhibitorDialogComponent,
    ExhibitorPDFDialogComponent,
    CountriesDialogComponent,
    EventGuestDialogComponent

  ],
  entryComponents: [
    SpinnerComponent,
    SnackBarIconComponent,
    AccountProfileComponent,
    AccountPasswordComponent,
    AccountDialogComponent,
    MemberDialogComponent,
    RegionalDialogComponent,
    MemberFileDialogComponent,
    RoomDialogComponent,
    TeamRoleDialogComponent,
    ProductDialogComponent,
    EventDialogComponent,
    EventDayDialogComponent,
    EventActivityDialogComponent,
    EventTopicDialogComponent,
    EventPreviewDialogComponent,
    ProductLotDialogComponent,
    ProductPriceDialogComponent,
    ConfirmComponent,
    OrderedDialogComponent,
    AlertComponent,
    StaffDialogComponent,
    TaxDialogComponent,
    OrderedFileDialogComponent,
    ProductCatPriceDialogComponent,
    PushDialogComponent,
    OrderedFailDialogComponent,
    OrderedViewerDialogComponent,
    SubcategoryDialogComponent,
    NewsDialogComponent,
    SponsorDialogComponent,
    SponsorCongressDialogComponent,
    PushSponsorDialogComponent,
    WebnarDialogComponent,
    WebnarViewDialogComponent,
    ProductRefundDialogComponent,
    RefundDialogComponent,
    EventSlotDialogComponent,
    TopicSlotDialogComponent,
    MemberDocumentDialogComponent,
    DocumentDialogComponent,
    VoucherDialogComponent,
    WaitingListDialogComponent,
    KnowledgeDialogComponent,
    CompanionDialogComponent,
    TransferDialogComponent,
    ConfigDialogComponent,
    EventTopicAgendaDialogComponent,
    EventStaffDialogComponent,
    SubscriptionDialogComponent,
    BannerDialogComponent,
    ReportDialogComponent,
    CriteriaDialogComponent,
    UploadDocumentDialogComponent,
    ReportSubscriptionDialogComponent,
    MemberChangedDialogComponent,
    ReportSubscriptionStaffDialogComponent,
    MemberDataDialogComponent,
    AnnuityDialogComponent,
    AnnuityCatPriceDialogComponent,
    AnnuityLotDialogComponent,
    AnnuityPriceDialogComponent,
    AnnuityPayDialogComponent,
    AnnuityViewerDialogComponent,
    Gn1DialogComponent,
    MemberAnnotationDialogComponent,
    MemberLinksDialogComponent,
    MemberSubcategoryDialogComponent,
    MemberViewerDialogComponent,
    DocumentFolderDialogComponent,
    DocumentApproveDialogComponent,
    DocumentMoveDialogComponent,
    MemberPaymentDialogComponent,
    DepartmentDialogComponent,
    ConventionCenterDialogComponent,
    ConventionRoomDialogComponent,
    MemberCollectDialogComponent,
    PushMembersDialogComponent,
    MemberGN1DialogComponent,
    MemberGN1WorkDialogComponent,
    FrontDeskRegisterConfirmComponent,
    MemberGn1ExcludedDialogComponent,
    MemberResidentDialogComponent,
    MemberTpiccvDialogComponent,
    MemberEducationDialogComponent,
    MemberBackgroundDialogComponent,
    SubcategoryDocDialogComponent,
    ProductDocPriceDialogComponent,
    LetterSubscriptionDialogComponent,
    LettersSpeakersDialogComponent,
    LettersSpeakersPreviewDialogComponent,
    InviteSpeakersDialogComponent,
    SpeakerMemberDataDialogComponent,
    CertificatesSubscriptionsDialogComponent,
    CertificatesSpeakersDialogComponent,
    CertificatesSpeakers_v2DialogComponent,
    AnnuityLetterDialogComponent,
    AnnuityValuesDialogComponent,
    AnnuityConfirmationDialogComponent,
    MemberEditPaymentDialogComponent,

    HeaderDialogComponent,

    DirectorsDialogComponent,
    DirectorsPeriodDialogComponent,
    StatuteDialogComponent,
    LinkDialogComponent,
    DeptoDialogComponent,

    ExamsDialogComponent,
    RegionalsDialogComponent,

    FileManagerComponent,
    CarouselDialogComponent,
    SiteNewsDialogComponent,
    YoutubeDialogComponent,
    GalleryDialogComponent,
    GalleryListDialogComponent,
    GalleryPhotoDialogComponent,
    SiteEventDialogComponent,
    BulletinDialogComponent,
    BulletinListDialogComponent,
    BulletinPdfDialogComponent,
    MagazineDialogComponent,
    TaviDocDialogComponent,
    TaviProfsDialogComponent,
    TaviCenterDialogComponent,
    ResidentDialogComponent,
    RegulationDialogComponent,
    GuidelineDialogComponent,
    CongressBeforeDialogComponent,
    CongressBeforePdfDialogComponent,
    SiteEventFormDialogComponent,
    BecomeMemberDialogComponent,
    CongressCurrentDialogComponent,
    VimeoDialogComponent,
    ArtigoCientificoDialogComponent,
    PDFsDialogComponent,
    MemberSiteChangedDialogComponent,
    ExhibitorDialogComponent,
    ExhibitorPDFDialogComponent,
    CountriesDialogComponent,
    EventGuestDialogComponent

  ],
  imports: [
    MaterialModule,

    HttpClientModule,
    MatOptionModule,

    BrowserModule,
    AppRoutingModule,

    FormsModule,
    ReactiveFormsModule,

    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    AngularFireAuthModule,

    FlexLayoutModule,
    LayoutModule,

    CKEditorModule,

    BrowserAnimationsModule,

    ClipboardModule,

  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    CryptoService,
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'fill'}} ],
  bootstrap: [ AppComponent ]
})

export class AppModule { }
